const { CONCEPT_DATA_TYPE_MIXED } = require("./common/LocalConst");

const ListMaritalStatus = [
  { value: 0, name: "Độc thân" }, //Single
  { value: 1, name: "Đính hôn" }, //Engaged
  { value: 2, name: "Đã kết hôn" }, //Married
  { value: 3, name: "Ly thân" }, //Separated
  { value: 4, name: "Đã ly hôn" }, //Divorced
];
const ListGender = [
  { id: "M", name: "Nam" },
  { id: "F", name: "Nữ" },
  { id: "U", name: "Không rõ" },
];
const GENDER_FEMALE = "female";
const GENDER_MALE = "male";

const GENDER_LIST = [
  { name: "Nữ", value: GENDER_FEMALE },
  { name: "Nam", value: GENDER_MALE },
];

const ListSortItem = [
  { value: 3, name: "Năm" },
  { value: 2, name: "Tháng" },
  { value: 1, name: "Tuần" },
];

const ListMonth = [
  { value: 1, name: "Tháng 1" },
  { value: 2, name: "Tháng 2" },
  { value: 3, name: "Tháng 3" },
  { value: 4, name: "Tháng 4" },
  { value: 5, name: "Tháng 5" },
  { value: 6, name: "Tháng 6" },
  { value: 7, name: "Tháng 7" },
  { value: 8, name: "Tháng 8" },
  { value: 9, name: "Tháng 9" },
  { value: 10, name: "Tháng 10" },
  { value: 11, name: "Tháng 11" },
  { value: 12, name: "Tháng 12" },
];

const ListFourWeek = [
  { value: 1, name: "Tuần 1" },
  { value: 2, name: "Tuần 2" },
  { value: 3, name: "Tuần 3" },
  { value: 4, name: "Tuần 4" },
];

const ListFiveWeek = [
  { value: 1, name: "Tuần 1" },
  { value: 2, name: "Tuần 2" },
  { value: 3, name: "Tuần 3" },
  { value: 4, name: "Tuần 4" },
  { value: 5, name: "Tuần 5" },
];

const ListYear = [{ value: 2022, name: "2022" }];

const ListFamilyRelationship = [
  { value: "Vợ chồng", name: "Vợ chồng" },
  { value: "Con", name: "Con" },
  { value: "Bố mẹ", name: "Bố mẹ" },
  { value: "Anh chị em", name: "Anh chị em" },
  { value: "Ông bà", name: "Ông bà" },
  { value: "Cháu", name: "Cháu" },
];
const ListHighSchoolEducation = [
  { value: 1, name: "1/12" },
  { value: 2, name: "2/12" },
  { value: 3, name: "3/12" },
  { value: 4, name: "4/12" },
  { value: 5, name: "5/12" },
  { value: 6, name: "6/12" },
  { value: 7, name: "7/12" },
  { value: 8, name: "8/12" },
  { value: 9, name: "9/12" },
  { value: 10, name: "10/12" },
  { value: 11, name: "11/12" },
  { value: 12, name: "12/12" },
  { value: 13, name: "Cấp I" },
  { value: 14, name: "Tốt nghiệp THCS/BTCS" },
  { value: 15, name: "Tốt nghiệp THPT/BTTH" },
];
const ListCivilServantType = [
  { value: 0, name: "Công chức hợp đồng" },
  { value: 1, name: "Công chức được tuyển dụng" },
];
const ListPosition = [
  { value: "1", name: "Chức vụ chính" },
  { value: "2", name: "Chức vụ kiêm nhiệm" },
];

const ListStatus = [
  { value: "-1", name: "Nghỉ" },
  { value: "0", name: "Đi làm" },
  { value: "1", name: "Làm online" },
  {
    value: "2",
    name: "Đi công tác",
  },
];

const ListApproveStatus = [
  { id: 1, name: "Chưa phê duyệt" },
  { id: 2, name: "Đã phê duyệt" },
];
const Priority = [
  { id: 1, name: "Thấp" },
  { id: 2, name: "Trung bình" },
  { id: 3, name: "Cao" },
  { id: 4, name: "Cấp bách" },
];

const ListFamilyComeFrom = [
  { id: 1, name: "Cán bộ" },
  { id: 2, name: "Công chức NN" },
  { id: 3, name: "Công chức(chế độ cũ)" },
  { id: 4, name: "Công nhân" },
  { id: 5, name: "Nông dân" },
  { id: 6, name: "Ngư dân" },
  { id: 7, name: "Quân nhân" },
  { id: 8, name: "Quân nhân(chế độ cũ)" },
  { id: 9, name: "Tiểu chủ" },
  { id: 10, name: "Tiểu thương" },
  { id: 11, name: "Thợ thủ công" },
];

const ListFamilyPriority = [
  { id: 1, name: "Anh hùng Lao động" },
  { id: 2, name: "Anh hùng LLVT" },
  { id: 3, name: "Bà mẹ VN anh hùng" },
  { id: 4, name: "BB có thương tật đặc biệt" },
  { id: 5, name: "Bệnh binh" },
  { id: 6, name: "GĐ có người bị địch bắt tù đày" },
  { id: 7, name: "GĐ liệt sĩ" },
  { id: 8, name: "Gia đình có công với CM" },
  { id: 9, name: "Gia đình thương binh" },
  { id: 10, name: "Lão thành CM" },
  { id: 11, name: "Người hưởng CS như T.binh" },
  { id: 12, name: "Quân nhân bị bệnh nghề nghiệp" },
  { id: 13, name: "TB có thương tật đặc biệt" },
];

const ListPriorityYourself = [
  { id: 1, name: "Anh hùng Lao động" },
  { id: 2, name: "Anh hùng LLVT" },
  { id: 3, name: "BB 1/4" },
  { id: 4, name: "BB 2/4" },
  { id: 5, name: "BB 3/4" },
  { id: 6, name: "BB 4/4" },
  { id: 7, name: "BB hạng 1 có thương tật đặc biệt" },
  { id: 8, name: "Bị địch bắt tù đày" },
  { id: 9, name: "Con thương/bệnh binh" },
  { id: 10, name: "Hạng khác" },
  { id: 11, name: "Người có công với cách mạng" },
  { id: 12, name: "Người hưởng CS như thương binh" },
  { id: 13, name: "Người tham gia kháng chiến" },
  { id: 14, name: "Quân nhân bị bệnh nghề nghiệp" },
  { id: 15, name: "Quân nhân bị tai nạn lao động" },
  { id: 16, name: "TB 1/4" },
  { id: 17, name: "TB 2/4" },
  { id: 18, name: "TB 3/4" },
  { id: 19, name: "TB 4/4" },
  { id: 20, name: "TB hạng 1 có thương tật đặc biệt" },
  { id: 21, name: "Thân nhân liệt sỹ" },
];

const AdminitractiveLevel = [
  { value: 1, name: "Cấp Tỉnh/Thành phố" },
  { value: 2, name: "Cấp Quận/Huyện" },
  { value: 3, name: "Cấp Xã/Phường" },
];

const ListLanguage = [
  { id: 1, name: "Tiếng Anh" },
  { id: 2, name: "Tiếng Trung Quốc (Quan Thoại)" },
  { id: 3, name: "Tiếng Hindi" },
  { id: 4, name: "Tiếng Tây Ban Nha" },
  { id: 5, name: "Tiếng Pháp" },
  { id: 6, name: "Tiếng Ả Rập (Chuẩn)" },
  { id: 7, name: "Tiếng Bengal" },
  { id: 8, name: "Tiếng Nga" },
  { id: 9, name: "Tiếng Bồ Đào Nha" },
  { id: 10, name: "Tiếng Indonesia" },
  { id: 11, name: "Tiếng Urdu" },
  { id: 12, name: "Tiếng Đức" },
  { id: 13, name: "Tiếng Nhật" },
  { id: 14, name: "Tiếng Swahili" },
  { id: 15, name: "Tiếng Marathi" },
  { id: 16, name: "Tiếng Telugu" },
  { id: 17, name: "Tiếng Thổ Nhĩ Kì" },
  { id: 18, name: "Tiếng Trung Quốc (Quảng Đông)" },
  { id: 19, name: "Tiếng Tamil" },
  { id: 20, name: "Tiếng Punjab (Tây)" },
  { id: 21, name: "Tiếng Trung Quốc (Ngô)" },
  { id: 22, name: "Tiếng Hàn" },
  { id: 23, name: "Tiếng Việt" },
  { id: 24, name: "Tiếng Hausa" },
  { id: 25, name: "Tiếng Java" },
  { id: 26, name: "Tiếng Ả Rập (Ai Cập)" },
  { id: 27, name: "Tiếng Italia" },
  { id: 28, name: "Tiếng Gujarat" },
  { id: 29, name: "Tiếng Thái" },
  { id: 30, name: "Tiếng Amhara" },
];

const REGEX_SPECIAL_CHARACTERS = /^[^<>{}^$`~]*$/;

const hrmFileFolder = "D:/Working/GLOBITS/ProjectV3/Hr-v3/Data/";

const Admin = "HIS_ADMIN";
const HRManager = "HR_MANAGER";
const User = "HR_USER";

const HCS_TYPE_LABTEST = "LabTest";
const HCS_TYPE_IMAGE = "diagnostic_imaging";
const HCS_TYPE_PROCEDURE = "Procedures";
const HCS_TYPE_SERVICE_SET = "ServiceSet";
const HCS_TYPE_SURGERY = "Surgery";

const CONCEPT_TYPE_LABTEST = "labtest";
const CONCEPT_TYPE_ADVISE = "advise";

const CONCEPT_DATA_TYPE_NUMERIC = "numeric";
const CONCEPT_DATA_TYPE_TEXT = "text";
const CONCEPT_DATA_TYPE_DATE = "date";
const CONCEPT_DATA_TYPE_BOOLEAN = "boolean";
const CONCEPT_DATA_TYPE_CODED = "coded";

const TITLE_NO_DATA = "Chưa có thông tin";
const ITEM_DATA_TYPE_INDEX_ONLY = 1;
const ITEM_DATA_TYPE_PAYMENT_ONLY = 2;
const ITEM_DATA_TYPE_INDEX_PAYMENT = 3;
const ITEM_DATA_TYPE = [
  { value: ITEM_DATA_TYPE_INDEX_ONLY, name: "Chỉ số" },
  { value: ITEM_DATA_TYPE_PAYMENT_ONLY, name: "Thanh toán" },
  { value: ITEM_DATA_TYPE_INDEX_PAYMENT, name: "Chỉ số và thanh toán" },
];
const PERFORM_ON = [
  { value: 1, name: "Mắt phải" },
  { value: 2, name: "Mắt trái" },
];
const ENCOUNTER_TYPE = [
  { value: "Vefraction_measurement", name: "Đo khúc xạ" },
  { value: "Glasse_measuring", name: "Đo kính" },
  { value: "Reception", name: "Tiếp đón" },
  { value: "examination", name: "Khám" },
  { value: "receive_treatment", name: "Tiếp nhận điều trị" },
  { value: "LabTest", name: "Xét nghiệm" },
  { value: "Procedures", name: "Thủ thuật" },
  { value: "Diagnostic_imaging", name: "Chẩn đoán bằng hình ảnh" },
  { value: "Surgery", name: "Phẫu thuật" },
  { value: "internal_examination", name: "Khám nội" },
  { value: "Prescription", name: "Kê đơn thuốc" },
];
const EYE_REFRACTION_VALUE = [
  { value: "Bình thường" },
  { value: "Bình thường - Lão thị" },
  { value: "Cận loạn thị" },
  { value: "Cận loạn - Lão thị" },
  { value: "Cận - Lão thị" },
  { value: "Cận thị" },
  { value: "Đếm ngón tay" },
  { value: "Loạn cận kép" },
  { value: "Loạn cận kép - Lão thị" },
  { value: "Loạn hỗn hợp" },
  { value: "Loạn thị" },
  { value: "Lão thị" },
  { value: "Loạn thị - Lão thị" },
  { value: "Loạn viễn - Lão thị" },
  { value: "Loạn viễn kép" },
  { value: "Loạn viễn kép - Lão thị" },
  { value: "Plano" },
  { value: "Viễn loạn thị" },
  { value: "Viễn thị" },
  { value: "Viễn - Lão thị" },
  // { value: "Cận thị" },
  // { value: "Loạn thị" },
  // { value: "Viễn thị" },
  // { value: "Lão thị" },
];
const APPOINTMENT_TYPE = [
  { value: 1, name: "Hẹn khám theo lịch của BS" },
  { value: 2, name: "Hẹn phẫu thuật" },
  { value: 3, name: "BN tự đặt qua web" },
  { value: 4, name: "BN đặt qua hotline/đặt qua nhân viên" },
];

const APPOINTMENT_RESOURCE_TYPE = [
  { value: 1, name: "Dịch vụ" },
  { value: 2, name: "Thuốc" },
  { value: 3, name: "Vật tư" },
];

const UNIT_TYPE = [
  { value: 1, name: "Dùng cho thuốc" },
  { value: 2, name: "Dùng cho Chỉ số xét nghiệm" },
  { value: 3, name: "Dùng cho tốc độ truyền dịch" },
  { value: 4, name: "Dùng cho dinh dưỡng" },
];

const TYPE_SHIFT_WORK = [
  { value: 1, name: "Sáng" },
  { value: 2, name: "Chiều" },
  { value: 3, name: "Tối" },
];

const REPEAT_TYPE = [
  { value: 1, name: "Tất cả các ngày trong tuần" },
  { value: 2, name: "Ngày hành chính (trừ T7,CN)" },
  { value: 3, name: "Cuối tuần (chỉ làm T7, CN)" },
];
const SERVICE_TYPE_CODE_SERVICE = "DG02";
const PATIENT_TYPE_SERVICE_CODES = [
  {
    code: SERVICE_TYPE_CODE_SERVICE,
    name: "Dịch vụ",
  },
];

const DEPARTMENT_MEDICAL_CLINIC = "K01";
const DEPARTMENT_CODES = [
  {
    code: DEPARTMENT_MEDICAL_CLINIC,
    name: "Phòng khám bệnh",
  },
];

const EPISODE_OF_CARE_TYPE_OUTPATIENT = 1;
const EPISODE_OF_CARE_TYPE_BOARDING = 2;

const EPISODE_OF_CARE_TYPE = [
  { value: EPISODE_OF_CARE_TYPE_OUTPATIENT, name: "Ngoại trú" },
  { value: EPISODE_OF_CARE_TYPE_BOARDING, name: "Nội trú" },
];

const NOT_PAYMENT = 0;
const PAYMENT = 1;

const STATUS_PAYMENT = [
  { value: NOT_PAYMENT, name: "Chưa thanh toán" },
  { value: PAYMENT, name: "Thanh toán" },
];

const PRICE_TYPE = [
  { value: 1, name: "Giá bảo hiểm" },
  { value: 2, name: "Giá bệnh viện" },
];
const DIS_TYPE = [
  { name: "Tự động", value: 0 },
  { name: "Thủ công", value: 1 },
];

const ReferralPartnerType = {
  INTERNAL: {name: "CTV thuộc LA", value: 0,},
  EXTERNAL: {name: "CTV ngoài LA", value: 1,},

  getListData() {
    return Object.keys(this)
        .filter(
            key =>
                typeof this[key] === "object" &&
                this[key] !== null &&
                "name" in this[key] &&
                "value" in this[key]
        )
        .map(key => this[key]);
  },
};

const ReferralPartnerIntroducerTypeEnum = {
  Staff: {name: "Nhân viên", value: 0,},
  Client: {name: "Khách hàng", value: 1,},
  ReferralPartner: {name: "CTV", value: 2,},

  getListData() {
    return Object.keys(this)
        .filter(
            key =>
                typeof this[key] === "object" &&
                this[key] !== null &&
                "name" in this[key] &&
                "value" in this[key]
        )
        .map(key => this[key]);
  },
};

const ReferralPartnerStatus = {
  NEW: {name: "Mới đăng ký", value: 0,},
  APPROVED: {name: "Đã duyệt", value: 1,},
  REJECTED: {name: "Từ chối", value: 2,},

  getListData() {
    return Object.keys(this)
        .filter(
            key =>
                typeof this[key] === "object" &&
                this[key] !== null &&
                "name" in this[key] &&
                "value" in this[key]
        )
        .map(key => this[key]);
  },
};
module.exports = Object.freeze({
  //ROOT_PATH : "/egret/",
  ListGender: ListGender,
  ListMaritalStatus: ListMaritalStatus,
  ListFamilyRelationship: ListFamilyRelationship,
  ListCivilServantType: ListCivilServantType,
  ListHighSchoolEducation: ListHighSchoolEducation,

  hrmFileFolder: hrmFileFolder,
  ListApproveStatus: ListApproveStatus,
  ListPosition: ListPosition,
  ListSortItem: ListSortItem,
  ListMonth: ListMonth,
  ListFourWeek: ListFourWeek,
  ListFiveWeek: ListFiveWeek,
  ListYear: ListYear,
  ListFamilyComeFrom: ListFamilyComeFrom,
  ListFamilyPriority: ListFamilyPriority,
  ListPriorityYourself: ListPriorityYourself,
  ListStatus: ListStatus,
  ListLanguage: ListLanguage,
  Priority: Priority,
  Admin: Admin,
  HRManager: HRManager,
  User: User,
  AdminitractiveLevel: AdminitractiveLevel,
  REGEX_SPECIAL_CHARACTERS: REGEX_SPECIAL_CHARACTERS,
  HCS_TYPE_LABTEST,
  HCS_TYPE_IMAGE,
  HCS_TYPE_PROCEDURE,
  HCS_TYPE_SERVICE_SET,
  HCS_TYPE_SURGERY,
  CONCEPT_TYPE_LABTEST,
  CONCEPT_TYPE_ADVISE,
  CONCEPT_DATA_TYPE_NUMERIC,
  CONCEPT_DATA_TYPE_TEXT,
  CONCEPT_DATA_TYPE_DATE,
  CONCEPT_DATA_TYPE_BOOLEAN,
  CONCEPT_DATA_TYPE_CODED,
  CONCEPT_DATA_TYPE_MIXED,
  TITLE_NO_DATA,
  ITEM_DATA_TYPE,
  ITEM_DATA_TYPE_INDEX_ONLY,
  ITEM_DATA_TYPE_PAYMENT_ONLY,
  ITEM_DATA_TYPE_INDEX_PAYMENT,
  PERFORM_ON,
  ENCOUNTER_TYPE,
  EYE_REFRACTION_VALUE,
  APPOINTMENT_TYPE,
  APPOINTMENT_RESOURCE_TYPE,
  UNIT_TYPE,
  TYPE_SHIFT_WORK,
  REPEAT_TYPE,
  PATIENT_TYPE_SERVICE_CODES,
  EPISODE_OF_CARE_TYPE,
  SERVICE_TYPE_CODE_SERVICE,
  DEPARTMENT_MEDICAL_CLINIC,
  EPISODE_OF_CARE_TYPE_BOARDING,
  NOT_PAYMENT,
  PAYMENT,
  STATUS_PAYMENT,
  PRICE_TYPE,
  GENDER_FEMALE,
  GENDER_MALE,
  GENDER_LIST,
  DIS_TYPE,
  ReferralPartnerType,
  ReferralPartnerIntroducerTypeEnum,
  ReferralPartnerStatus
});
